var _a, _b;
import { EventSubscriber } from '@verdant-web/common';
export const UPDATE = Symbol('entity-file-update');
export const MARK_FAILED = Symbol('entity-file-mark-failed');
/**
 * Provides a consistent interface for files used in an app via
 * Entity access.
 */
export class EntityFile extends EventSubscriber {
    constructor(id, { downloadRemote = false, } = {}) {
        super();
        this.id = id;
        // cached object URL for a local blob file, if applicable
        this._objectUrl = null;
        this._fileData = null;
        this._loading = true;
        this._failed = false;
        this._downloadRemote = false;
        this[_a] = (fileData) => {
            this._loading = false;
            this._failed = false;
            this._fileData = fileData;
            if (fileData.file) {
                if (this._objectUrl) {
                    URL.revokeObjectURL(this._objectUrl);
                }
                this._objectUrl = URL.createObjectURL(fileData.file);
            }
            this.emit('change');
        };
        this[_b] = () => {
            this._failed = true;
            this._loading = false;
            this.emit('change');
        };
        this.destroy = () => {
            if (this._objectUrl) {
                URL.revokeObjectURL(this._objectUrl);
            }
            this.dispose();
        };
        this._downloadRemote = downloadRemote;
    }
    get downloadRemote() {
        return this._downloadRemote;
    }
    get isFile() {
        return true;
    }
    get url() {
        var _c, _d;
        if (this.loading)
            return null;
        if (this._objectUrl)
            return this._objectUrl;
        return (_d = (_c = this._fileData) === null || _c === void 0 ? void 0 : _c.url) !== null && _d !== void 0 ? _d : null;
    }
    get name() {
        var _c, _d;
        return (_d = (_c = this._fileData) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : null;
    }
    get type() {
        var _c, _d;
        return (_d = (_c = this._fileData) === null || _c === void 0 ? void 0 : _c.type) !== null && _d !== void 0 ? _d : null;
    }
    get loading() {
        return this._loading;
    }
    get failed() {
        return this._failed;
    }
    getSnapshot() {
        return {
            id: this.id,
            url: this.loading || this.failed ? undefined : this.url,
        };
    }
}
_a = UPDATE, _b = MARK_FAILED;
//# sourceMappingURL=EntityFile.js.map